(function () {
  'use strict';

  const DISCOUNT_COLOR = '#2c8d02';

  function isB2BCustomer() {
    if (typeof window.BSS_B2B !== 'undefined' && window.BSS_B2B) return true;
    const tags =
      (window.theme && window.theme.customer && window.theme.customer.tags) ||
      (window.__st && window.__st.cust_tags) || [];
    const tagList = Array.isArray(tags) ? tags : String(tags).split(',');
    if (tagList.some(t => /b2b|wholesale|atacado|revenda/i.test(String(t).trim()))) return true;
    if (document.querySelector('.bss-b2b-custom-price,.bss-b2b-price,[class^="bss-b2b"]')) return true;
    return false;
  }

  class BoughtTogetherPricing {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector('.bought-together-products__wrapper');
      this._b2b = isB2BCustomer();
      this._applying = false;
      this._timer = null;
      this._t1 = null;
      this._t2 = null;
      this.observers = [];
    }

    start() {
      if (!this.wrapper) return;
      this.waitForItems(() => this.setup());
    }

    waitForItems(cb, attempts = 0) {
      if (this.getItems().length > 0) return cb();
      if (attempts > 30) return;
      setTimeout(() => this.waitForItems(cb, attempts + 1), 200);
    }

    getItems() {
      return Array.from(
        this.section.querySelectorAll('.bought-together-list .product-item')
      );
    }

    setup() {
      this.snapshotPrices();

      if (this._b2b) {
        this.ensureCompareMarkup();
        this.observeBSSPrices();
        [500, 1500, 3000, 6000].forEach(t => this.schedule(t));
      }

      this.attachListeners();

      // Only react to element additions (nodeType 1) — not text node writes
      // from our own apply(), which would cause an infinite loop.
      const structureObs = new MutationObserver(mutations => {
        if (this._applying) return;
        const hasNewElements = mutations.some(m =>
          Array.from(m.addedNodes).some(n => n.nodeType === 1)
        );
        if (hasNewElements) {
          this.snapshotPrices();
          this.attachListeners();
          this.schedule(100);
        }
      });
      structureObs.observe(this.section, { childList: true, subtree: true });
      this.observers.push(structureObs);

      if (!this._b2b) this.watchForB2B();

      this.section.addEventListener('change', (e) => {
        if (e.target.matches('select, input[type="radio"]')) this.schedule(900);
      });

      this.schedule(300);
    }

    // Snapshot Liquid-rendered prices once into custom attributes so nothing
    // can corrupt our source of truth later.
    snapshotPrices() {
      this.getItems().forEach(item => {
        if (item.dataset.origPrice) return;
        const cb = item.querySelector('.bought-together-checkbox');
        const priceCents   = (cb && cb.dataset.price)   ? cb.dataset.price        : '0';
        const compareCents = item.dataset.comparePrice   ? item.dataset.comparePrice : priceCents;
        item.dataset.origPrice   = priceCents;
        item.dataset.origCompare = compareCents;
      });
    }

    attachListeners() {
      this.section.querySelectorAll('.bought-together-checkbox').forEach(cb => {
        if (cb._btAttached) return;
        cb._btAttached = true;
        const handler = () => {
          this.schedule(30);
          clearTimeout(this._t1);
          clearTimeout(this._t2);
          this._t1 = setTimeout(() => this.recalc(), 250);
          this._t2 = setTimeout(() => this.recalc(), 700);
        };
        cb.addEventListener('change', handler);
        cb.addEventListener('click',  handler);
      });
    }

    observeBSSPrices() {
      this.section.querySelectorAll('[bss-b2b-product-price]').forEach(el => {
        const obs = new MutationObserver(() => {
          if (!this._applying) this.schedule(80);
        });
        obs.observe(el, { childList: true, subtree: true, characterData: true });
        this.observers.push(obs);
      });
    }

    watchForB2B() {
      const start = Date.now();
      const check = () => {
        if (isB2BCustomer()) {
          this._b2b = true;
          this.ensureCompareMarkup();
          this.observeBSSPrices();
          [0, 500, 1500].forEach(t => this.schedule(t));
          return;
        }
        if (Date.now() - start < 12000) setTimeout(check, 500);
      };
      setTimeout(check, 500);
    }

    ensureCompareMarkup() {
      const bundle = this.section.querySelector('.bundle-price');
      if (!bundle) return;

      if (!bundle.querySelector('s.compare-price')) {
        const s = document.createElement('s');
        s.className = 'compare-price grey-color text-size subheading_weight';
        s.style.display = 'none';
        const price = bundle.querySelector('.price');
        price ? price.insertAdjacentElement('afterend', s) : bundle.appendChild(s);
      }

      if (!bundle.querySelector('.saving-price-js')) {
        const wrap = document.createElement('div');
        wrap.className = 'saving-price saving-price-js product__badges flex';
        wrap.style.display = 'none';
        const badge = document.createElement('span');
        badge.className = 'price-saving price-item product__badges-sale rounded fs-13 subheading_weight';
        wrap.appendChild(badge);
        bundle.appendChild(wrap);
      }
    }

    schedule(delay) {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this.recalc(), delay);
    }

    parsePrice(text) {
      if (!text) return 0;
      const matches = text.replace(/\s/g, '').match(/-?[\d.,]+/g);
      if (!matches || !matches.length) return 0;
      const raw = matches[matches.length - 1];
      const lc = raw.lastIndexOf(','), ld = raw.lastIndexOf('.');
      let n;
      if (lc === -1 && ld === -1) n = raw;
      else if (lc > ld) n = raw.replace(/\./g, '').replace(',', '.');
      else n = raw.replace(/,/g, '');
      const v = parseFloat(n);
      return isNaN(v) ? 0 : v;
    }

    formatMoney(amount) {
      const cents = Math.round(amount * 100);
      const fmt = (window.theme && window.theme.moneyFormat)
        || (window.Shopify && window.Shopify.money_format)
        || '${{amount}}';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try { return window.Shopify.formatMoney(cents, fmt); } catch (_) {}
      }
      return amount.toFixed(2);
    }

    getBSSPrice(item) {
      const c = item.querySelector('[bss-b2b-product-price]');
      if (!c) return 0;
      const el =
        c.querySelector('.bss-b2b-custom-price,.bss-b2b-price,[class*="bss-b2b"]:not([class*="compare"])') ||
        c.querySelector('.price-item--sale,.price__sale .price-item,.sale-color') ||
        c.querySelector('.price-item--regular,.price__regular .price-item');
      return el ? this.parsePrice(el.textContent) : this.parsePrice(c.textContent);
    }

    recalc() {
      const items = this.getItems();
      if (!items.length) return;

      let total        = 0;
      let totalCompare = 0;
      let hasSale      = false;

      items.forEach(item => {
        const cb = item.querySelector('.bought-together-checkbox');
        if (cb && !cb.checked) return;

        const origPrice   = parseInt(item.dataset.origPrice   || '0', 10) / 100;
        const origCompare = parseInt(item.dataset.origCompare || '0', 10) / 100;

        // Real Shopify sale — used for non-B2B strikethrough.
        if (origCompare > origPrice + 0.005) hasSale = true;

        // Current price: BSS wholesale (B2B) or Liquid original (non-B2B).
        const current = this._b2b
          ? (this.getBSSPrice(item) || origPrice)
          : origPrice;

        total += current;

        if (this._b2b) {
          // B2B strikethrough = sum of original retail prices (before BSS).
          totalCompare += origPrice;
        } else {
          // Non-B2B strikethrough = Shopify compare-at (only if a sale exists).
          totalCompare += (origCompare > origPrice + 0.005) ? origCompare : current;
        }
      });

      if (this._b2b) {
        // Show strikethrough whenever BSS has applied any discount at all.
        this.apply(total, totalCompare > total + 0.005 ? totalCompare : 0);
      } else {
        // Show strikethrough only when a real Shopify sale exists.
        this.apply(total, hasSale ? totalCompare : 0);
      }
    }

    apply(total, compare) {
      this._applying = true;
      const showCompare = compare > total + 0.005;

      // ── Desktop bundle price ───────────────────────────────────────────────
      this.section.querySelectorAll('.bundle-price .price').forEach(el => {
        el.textContent = this.formatMoney(total);
        if (this._b2b) {
          el.style.color = showCompare ? DISCOUNT_COLOR : '';
          el.classList.toggle('sale-color', showCompare);
        }
      });

      // ── Desktop strikethrough ──────────────────────────────────────────────
      const strike = this.section.querySelector('.bundle-price s.compare-price');
      if (strike) {
        if (showCompare) {
          strike.textContent = this.formatMoney(compare);
          strike.classList.remove('hidden');
          strike.style.display = 'inline';
        } else {
          strike.textContent = '';
          strike.classList.add('hidden');
          strike.style.display = 'none';
        }
      }

      // ── Savings badge (B2B only) ───────────────────────────────────────────
      const saving = this.section.querySelector('.bundle-price .saving-price-js');
      if (saving) {
        const badge = saving.querySelector('.price-saving');
        if (this._b2b && showCompare) {
          const pct = Math.round(((compare - total) / compare) * 100);
          if (badge) {
            badge.textContent = '-' + pct + '%';
            badge.style.background = DISCOUNT_COLOR;
            badge.style.color = '#fff';
          }
          saving.style.display = '';
        } else {
          saving.style.display = 'none';
        }
      }

      // ── Mobile button total ────────────────────────────────────────────────
      this.section.querySelectorAll(
        'button-bought-together-mobile .total-price .price'
      ).forEach(el => {
        el.textContent = this.formatMoney(total);
        if (this._b2b) el.style.color = showCompare ? DISCOUNT_COLOR : '';
      });

      const mobileStrike = this.section.querySelector(
        'button-bought-together-mobile .total-price s.compare-price'
      );
      if (mobileStrike) {
        if (showCompare) {
          mobileStrike.textContent = this.formatMoney(compare);
          mobileStrike.classList.remove('hidden');
          mobileStrike.style.display = 'inline';
        } else {
          mobileStrike.textContent = '';
          mobileStrike.style.display = 'none';
        }
      }

      setTimeout(() => { this._applying = false; }, 50);
    }
  }

  function boot() {
    document.querySelectorAll('.section__bought-together-products').forEach(s => {
      if (s._btPricing) return;
      const instance = new BoughtTogetherPricing(s);
      s._btPricing = instance;
      instance.start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();